import React from 'react'
import { Field } from 'redux-form'
import { Grid, Button, CircularProgress } from '@material-ui/core'

import { minLength8 } from 'services/validations'

import { Input, SelectInput } from 'components'

import {
  DISPATCHER_USER_ROLE,
  PARTNER_USER_ROLE,
  DRIVER_USER_ROLE,
  CARRIER_USER_ROLE,
  LIMITED_DISPATCHER_USER_ROLE,
  ALIMAN_DISPATCHER_USER_ROLE,
} from 'constants/config'

export const CreateUserFormBase = ({ classes, handleSubmit, createUser, isLoading }) => (
  <Grid
    container
    spacing={16}
    onSubmit={handleSubmit(createUser)}
    component='form'
    alignItems='center'
  >

    <Grid item xs>
      <Field
        required
        fullWidth
        name='email'
        label='Email'
        margin='normal'
        component={Input}
      />
    </Grid>

    <Grid item xs>
      <Field
        required
        fullWidth
        name='password'
        label='Пароль'
        margin='normal'
        validate={minLength8}
        component={Input}
      />
    </Grid>

    <Grid item xs>
      <Field
        required
        fullWidth
        name='displayName'
        label='Імя'
        margin='normal'
        component={Input}
      />
    </Grid>

    <Grid item xs>
      <Field
        required
        fullWidth
        name='role'
        label='Роль'
        margin='normal'
        component={SelectInput}
      >
        <option value='' />
        <option value={DISPATCHER_USER_ROLE}>Диспетчер</option>
        <option value={PARTNER_USER_ROLE}>Партнер</option>
        <option value={DRIVER_USER_ROLE}>Водій</option>
        <option value={LIMITED_DISPATCHER_USER_ROLE}>Обмежений диспетчер</option>
        <option value={CARRIER_USER_ROLE}>Перевізник</option>
        <option value={ALIMAN_DISPATCHER_USER_ROLE}>Аліман диспетчер</option>
      </Field>
    </Grid>

    <Grid item xs>
      <Button
        type='submit'
        variant='contained'
        disabled={isLoading}
        className={classes.button}
      >
        Добавити
        {isLoading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </Button>
    </Grid>

  </Grid>
)



// WEBPACK FOOTER //
// ./src/components/Users/components/CreateUserForm/CreateUserForm.js